// extracted by mini-css-extract-plugin
export var actionIcon = "_rg-0";